<template>
    <Head title="Login" />
  <div class="p-6 min-h-screen flex justify-center items-center light">
    <div class="w-full max-w-xl	">
        <Link :href="route('home')"><logo class="block mx-auto w-full max-w-xs fill-white" height="50" /></Link>
      <form class="mt-8 bg-white dark:bg-slate-900 border border-gray-100 rounded-lg shadow-xl overflow-hidden" @submit.prevent="login">
        <div class="px-10 py-12">
          <h2 class="text-center font-bold text-xl">{{ __('Registration') }}</h2>
          <div class="mx-auto mt-2 mb-6 w-24 border-b" />
            <flash-messages />
            <div class="flex flex-wrap -mb-8 -mr-6 p-3">
                <text-input v-model="form.first_name" :error="form.errors.first_name" class="pb-8 pr-6 w-full lg:w-1/2" label="First name" type="text" autofocus autocapitalize="off" :is_required="true" @blur="setUsername" required />
                <text-input v-model="form.last_name" :error="form.errors.last_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Last name" type="text" autofocus autocapitalize="off" :is_required="true" @blur="setUsername" required />
                <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/2" label="Email" type="email" autofocus autocapitalize="off" :is_required="true" required />
                <text-input v-model="form.username" :error="form.errors.username" class="pb-8 pr-6 w-full lg:w-1/2" label="Username" type="text" autofocus autocapitalize="off" :is_required="true" required />
                <select-input v-model="form.country_id" :error="form.errors.country_id" class="pr-6 pb-8 w-full lg:w-1/2" :label="__('Country')">
                    <option :value="null" />
                    <option v-for="c in countries" :key="c.id" :value="c.id">{{ __(c.name) }}</option>
                </select-input>
                <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="City" type="text" autofocus autocapitalize="off" />
                <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full" label="Phone" type="text" autofocus autocapitalize="off" />
                <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full" label="Address" type="text" autofocus autocapitalize="off" />
                <text-input v-model="form.password" :error="form.errors.password" class="pb-8 pr-6 w-full lg:w-1/2" label="Password" type="password" :is_required="true" required />
                <text-input v-model="form.confirm_password" :error="form.errors.confirm_password" class="pb-8 pr-6 w-full lg:w-1/2" label="Confirm Password" type="password" :is_required="true" required />
                <loading-button :loading="form.processing" class="ml-auto btn-indigo w-full items-center justify-center" type="submit">Submit</loading-button>
            </div>
            <div class="mt-8 flex justify-center">Already have an account? <Link class="ml-2" :href="route('login')">Login</Link></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FlashMessages from '@/Shared/FlashMessages'
import { Head, Link } from '@inertiajs/inertia-vue3'

export default {
  metaInfo: { title: 'Login' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
      SelectInput,
      Head,
      Link,
      FlashMessages,
  },
    props: {
        is_demo: Number,
        countries: Array
    },
  data() {
    return {
      form: this.$inertia.form({
        first_name: '',
        last_name: '',
        username: '',
          email: '',
          phone: '',
          city: '',
          country_id: '',
        address: '',
        password: '',
        confirm_password: '',
      }),
    }
  },
  methods: {
      setUsername(){
          this.checkUsername(this.form.first_name+' '+this.form.last_name)
      },
      checkUsername(name){
          this.axios.post(this.route('user.username.check'), {name: name}).then((response) => {
              if(response.data){
                  if(!response.data.username){
                      this.form.username = name.replace(/[^a-zA-Z0-9]/g,'-').toLowerCase()
                      if(this.form.username.charAt(this.form.username.length - 1) === '-'){
                          this.form.username = this.form.username.slice(0,-1)
                      }
                  }else{
                      const link = name.replace(/[^a-zA-Z0-9]/g,'-').toLowerCase()
                      const char = link.substr(link.length - 1)
                      const int = parseInt(char)
                      if(!isNaN(int)){
                          this.form.username = link.substring(0, link.length - 1) + (int+1)
                      }else{
                          this.form.username = link + 1
                      }
                  }
              }
          }).catch((error) => {
              console.log(error)
          })
      },
      login() {
          if(this.form.password !== this.form.confirm_password){
              alert('Your password is not matched correctly.')
              return
          }
          this.form.post(this.route('register.store'))
      },
      autofillLogin(e, role){
          e.preventDefault()
          const roleEmails = { 'admin': 'john.due.helo@mail.com', 'manager': 'robert.slaughter@mail.com', 'customer' : 'mmarks@example.com'}
          this.form.email = roleEmails[role]
          this.form.password = 'secret'
          this.login();
      }
  }
}
</script>
